<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">新增</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #operation="row">
          <el-button type="primary" size="mini" @click="handleEdit(row.data)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDel(row.data)">删除</el-button>
        </template>
      </com-table>
    </com-card>
    <the-created-type ref="createdType" @update="update"></the-created-type>
  </com-page>
</template>

<script>
import { typeListApi, delQuestionTypeApi } from '@/api/help-center'

import theCreatedType from './components/the-created-type'

export default {
  components: { theCreatedType },
  data() {
    return {
      api: typeListApi,
      searchColumns: [
        {
          label: '分类名称',
          prop: 'name',
          type: 'input'
        }
      ],
      columns: [
        {
          label: '分类名称',
          prop: 'name'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ]
    }
  },
  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        row
      }
      this.$refs.createdType.open(params)
    },
    handleCreated() {
      const params = {
        type: 'created'
      }
      this.$refs.createdType.open(params)
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleDel(row) {
      this.$confirm('是否确认删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          delQuestionTypeApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
